import { type Item } from "@/api/items";

import { itemEntity } from "./entities";
import { EntityCombobox } from "./EntityCombobox";

interface Props {
  value: number | null;
  onChange: (id: number | null) => void;
  size?: "sm" | "default";
  className?: string;
  allowClear?: boolean;
}

export function ItemCombobox({ allowClear = true, ...rest }: Props) {
  return (
    <EntityCombobox<Item>
      descriptor={itemEntity}
      allowClear={allowClear}
      {...rest}
    />
  );
}
